export default [
    {
        name:"accesory",
        value:"Accesorio"
    },
    {
        name:"boxer",
        value:"Boxer"
    },
    {
        name:"coat",
        value:"Buzo"
    },
    {
        name:"shirt",
        value:"Camisa"
    },
    {
        name:"jacket",
        value:"Campera"
    },
    {
        name:"chomba",
        value:"Chomba"
    },
    {
        name:"pant",
        value:"Pantalón"
    },
    {
        name:"fragrance",
        value:"Perfume"
    },
    {
        name:"t-shirt",
        value:"Remera"
    },
    {
        name:"sweater",
        value:"Sweater"
    },
    {
        name:"suit",
        value:"Traje"
    },
    {
        name:"shoes",
        value:"Calzado"
    }
]
